<p>
  Sehr geehrte Damen und Herren,
</p>
<p>
  hiermit informieren wir Sie über die Verarbeitung Ihrer personenbezogenen Daten durch uns und die Ihnen nach den
  datenschutzrechtlichen Regelungen zustehenden Ansprüche und Rechte.
</p>
<h2>
  1. Wer ist für die Datenverarbeitung verantwortlich und an wen kann ich mich wenden?
</h2>
<p>
  Verantwortlicher im datenschutzrechtlichen Sinne ist:
</p>
<p>
  Just Farming GmbH<br>
  Stockumer Straße 475<br>
  44227 Dortmund<br>
  Deutschland
</p>
<p>
  Internet: <a href="https://www.just-farming.de">www.just-farming.de</a><br>
  E-Mail: <a href="mailto:info@just-farming.de">info@just-farming.de</a><br>
  Telefon: <a href="tel:+4923122613790">+49 231 2261379-0</a></p>
<p>
  Sie erreichen unseren Datenschutzbeauftragten unter:
</p>
<p>
  heyData GmbH<br>
  Schützenstraße 5<br>
  10117 Berlin<br>
  Deutschland
</p>
<p>
  Internet: <a href="https://www.heydata.eu">www.heydata.eu</a><br>
  E-Mail: <a href="mailto:datenschutz@heydata.eu">datenschutz@heydata.eu</a><br>
  Telefon: <a href="tel:+498941325320">+49 89 41325320</a></p>
<h2>
  2. Welche Quellen und Daten nutzen wir?
</h2>
<p>
  Wir verarbeiten personenbezogene Daten, die wir im Rahmen unserer Geschäftsbeziehung von Ihnen erhalten.
</p>
<p>
  Relevante personenbezogene Daten sind Personalien (z. B. Name, berufliche Adresse und andere berufliche
  Kontaktdaten), Ihr Arbeitgeber sowie Daten über Ihre Nutzung von unseren angebotenen Telemedien (z. B. Zeitpunkt
  des Aufrufs unserer Webseiten, Apps oder Newsletter, angeklickte Seiten von uns bzw.
  Einträge) sowie andere mit den genannten Kategorien vergleichbare Daten sein.
</p>
<p>
  Soweit Sie den in das Just Farming Portal integrierten Chatbot nutzen, verarbeiten wir zusätzlich Ihre Eingaben
  (Ihre Fragen und Nachrichten an den Chatbot) sowie den Verlauf Ihrer Chatbot-Konversationen. Nutzen Sie
  Funktionen, mit denen der Chatbot auf Ihre im Portal hinterlegten Belege und Daten zugreift, verarbeiten wir die
  hierfür erforderlichen Inhalte (z. B. Angaben aus Ihren Belegen, Rechnungen und Finanzdaten), um Ihre Fragen zu
  beantworten und Ihnen individuelle Auswertungen Ihrer eigenen Daten bereitzustellen.
</p>
<h2>
  3. Wofür verarbeiten wir Ihre Daten (Zweck der Verarbeitung) und auf welcher Rechtsgrundlage?
</h2>
<h3>
  a) Zur Erfüllung von vertraglichen Pflichten (Art. 6 Abs. 1 Buchst. b DS-GVO)
</h3>
<p>
  Die Verarbeitung personenbezogener Daten (Art. 4 Nr. 2 DSGVO) erfolgt zur Vorbereitung und Durchführung Ihrer
  Bestellungen (Kunden) bzw. unserer Einkäufe (Zulieferer).
</p>
<p>
  Hierzu gehört auch die Bereitstellung des in das Portal integrierten Chatbots: Wir verarbeiten Ihre Eingaben und –
  soweit Sie entsprechende Funktionen nutzen – Ihre im Portal hinterlegten Daten, um Ihre Fragen zur Nutzung des
  Portals und seiner Anwendungen zu beantworten und Ihnen auf Anfrage individuelle Auswertungen Ihrer eigenen Daten
  bereitzustellen. Die Bereitstellung dieser Auswertungen ist Bestandteil der vertraglich geschuldeten Leistung und
  zu deren Erbringung erforderlich.
</p>
<h3>
  b) Im Rahmen der Interessenabwägung (Art. 6 Abs. 1 Buchst. f DSGVO)
</h3>
<p>
  Soweit erforderlich, verarbeiten wir Ihre Daten über die eigentliche Erfüllung des Vertrages hinaus zur Wahrung
  unserer berechtigten Interessen.
</p>
<p>
  Beispiele:
</p>
<ul>
  <li>
    Prüfung und Optimierung von Verfahren zur Bedarfsanalyse und direkter Kundenansprache
  </li>
  <li>
    Werbung oder Markt- und Meinungsforschung, soweit Sie der Nutzung Ihrer Daten nicht widersprochen haben
  </li>
  <li>
    Geltendmachung rechtlicher Ansprüche und Verteidigung bei rechtlichen Streitigkeiten
  </li>
</ul>
<p>
  Darüber hinaus werten wir die Chatbot-Konversationen (Ihre Eingaben und die Antworten des Chatbots) in
  pseudonymisierter Form aus, um den Chatbot und seine Antwortqualität fortlaufend zu verbessern. Vor der Auswertung
  wird die Zuordnung zu Ihrem Nutzerkonto durch eine Kennung ersetzt. Die von Ihnen hinterlegten Beleg- und
  Finanzdaten sind von dieser Auswertung ausgenommen. Die Konversationen werden nicht zum Training von KI-Modellen
  Dritter verwendet. Rechtsgrundlage ist unser berechtigtes Interesse an einem funktionsfähigen und qualitativ
  hochwertigen Angebot (Art. 6 Abs. 1 lit. f DSGVO). Sie können dieser Verarbeitung aus Gründen, die sich aus Ihrer
  besonderen Situation ergeben, jederzeit widersprechen (siehe Ziffer 8).
</p>
<h3>
  c) Aufgrund Ihrer Einwilligung (Art. 6 Abs. 1 Buchst. a DSGVO)
</h3>
<p>
  Soweit Sie uns eine Einwilligung zur Verarbeitung von personenbezogenen Daten für bestimmte Zwecke erteilt haben,
  ist die Rechtmäßigkeit dieser Verarbeitung auf Basis Ihrer Einwilligung gegeben. Eine erteilte Einwilligung kann
  jederzeit widerrufen werden. Bitte beachten Sie, dass der Widerruf erst für die Zukunft wirkt. Verarbeitungen,
  die vor dem Widerruf erfolgt sind, sind davon nicht betroffen.
</p>
<p>
  Im Just Farming Portal holen wir über einen Einwilligungsdialog Ihre Einwilligung ein, um Nutzungsdaten und
  Fehlerberichte zu verarbeiten. Zweck der Verarbeitung der Nutzungsdaten ist die Optimierung und Weiterentwicklung
  des Portals und seiner Anwendungen sowie die Verbesserung der Stabilität. Zweck der Fehlerberichte ist die
  Unterstützung des Benutzerservice bei der Lösung von Problemen. Rechtsgrundlage ist jeweils Ihre Einwilligung
  (Art. 6 Abs. 1 lit. a DSGVO). Die Einwilligung ist freiwillig; Sie können sie jederzeit mit Wirkung für die
  Zukunft widerrufen.
</p>
<h3>
  d) Aufgrund gesetzlicher Vorgaben (Art. 6 Abs. 1 Buchst. c DSGVO) oder im öffentlichen Interesse (Art. 6 Abs. 1
  Buchst. e DSGVO)
</h3>
<p>
  Ausnahmsweise kann es vorkommen, dass wir auf Grund gesetzlicher Vorgaben bzw. im öffentlichen Interesse Daten
  verarbeiten müssen (bspw. auf Grund behördlicher Auskunftsersuchen).
</p>
<h2>
  4. Wer bekommt meine Daten?
</h2>
<p>
  Innerhalb unseres Hauses erhalten diejenigen Personen Zugriff auf Ihre Daten, die diese zur Erfüllung unserer
  vertraglichen und gesetzlichen Pflichten brauchen.
</p>
<p>
  Auch von uns eingesetzte Auftragsverarbeiter (Art. 28 DS-GVO) können zu diesen genannten Zwecken Daten erhalten.
  Dies sind Unternehmen in den Kategorien IT-Dienstleistungen, Logistik,
  Druckdienstleistungen, Telekommunikation, Inkasso, Beratung und Consulting sowie Vertrieb und Marketing.
</p>
<h2>
  5. Wie lange werden meine Daten gespeichert?
</h2>
<p>
  Soweit erforderlich, verarbeiten und speichern wir Ihre personenbezogenen Daten für die Dauer unserer
  Geschäftsbeziehung, was beispielsweise auch die Anbahnung und die Abwicklung eines Vertrages umfasst.
</p>
<p>
  Darüber hinaus unterliegen wir verschiedenen Aufbewahrungs- und Dokumentationspflichten, die sich unter anderem
  aus dem Handelsgesetzbuch (HGB) und der Abgabenordnung (AO) ergeben. Die dort vorgegebenen Fristen zur
  Aufbewahrung bzw. Dokumentation betragen bis zu zehn Jahre.
</p>
<p>
  Schließlich beurteilt sich die Speicherdauer auch nach den gesetzlichen Verjährungsfristen, die zum Beispiel nach
  den §§ 195 ff. des Bürgerlichen Gesetzbuches (BGB) in der Regel 3 Jahre, in gewissen Fällen aber auch bis zu
  dreißig Jahre betragen können.
</p>
<p>
  Ihre Chatbot-Konversationen speichern wir, solange Ihr Nutzerkonto aktiv ist, damit Ihnen Ihr Verlauf für
  wiederkehrende Aufgaben zur Verfügung steht. Nach einem Zeitraum der Inaktivität von 15 Monaten löschen wir die
  Konversationen automatisch. Darüber hinaus können Sie einzelne Konversationen oder Ihr gesamtes Konto jederzeit
  selbst löschen. Bei einer Löschung entfernen wir neben den gespeicherten Verläufen auch die zugehörigen
  abgeleiteten Daten (insbesondere die als Vektoren gespeicherten Repräsentationen). Die oben genannten handels- und
  steuerrechtlichen Aufbewahrungspflichten finden auf die Chatbot-Verläufe keine Anwendung, da diese lediglich eine
  temporäre Arbeitskopie zur Nutzung darstellen; maßgeblich bleiben insoweit die Originaldaten in den jeweiligen
  Fachsystemen.
</p>
<p>
  Die zur Verbesserung des Chatbots pseudonymisiert ausgewerteten Konversationsdaten löschen wir spätestens zwölf
  Monate nach dem jeweiligen Gespräch. Löschen Sie Ihr Nutzerkonto oder widersprechen Sie der Auswertung, werden
  diese Daten ebenfalls gelöscht.
</p>
<p>
  Die auf Grundlage Ihrer Einwilligung verarbeiteten Nutzungsdaten werden nach 7 Tagen gelöscht. Daten aus
  Fehlerberichten werden nach 30 Tagen gelöscht. Zusammenfassende Berichte werden nicht gelöscht.
</p>
<h2>
  6. Werden Daten in ein Drittland oder an eine internationale Organisation übermittelt?
</h2>
<p>
  Eine Datenübermittlung in Drittstaaten (Staaten außerhalb des Europäischen Wirtschaftsraums – EWR) findet nur
  statt, soweit dies zur Ausführung Ihrer Aufträge erforderlich ist.
</p>
<h2>
  7. Welche Datenschutzrechte habe ich?
</h2>
<p>
  Jede betroffene Person hat das Recht auf Auskunft nach Art. 15 DS-GVO, das Recht auf Berichtigung nach Art. 16
  DS-GVO, das Recht auf Löschung nach Art. 17 DS-GVO, das Recht auf Einschränkung der Verarbeitung nach Art. 18
  DS-GVO sowie das Recht auf Datenübertragbarkeit aus Art. 20 DS-GVO. Beim Auskunftsrecht und beim Löschungsrecht
  gelten die Einschränkungen nach §§ 34 und 35 BDSG.
</p>
<p>
  Darüber hinaus besteht ein Beschwerderecht bei der zuständigen Datenschutzaufsichtsbehörde (Art. 77 DS-GVO i.V.m.
  § 19 BDSG):
</p>
<p>
  Die Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen
  Kavalleriestr. 2-4<br>
  40213 Düsseldorf<br>
  <br>
  E-Mail: <a href="mailto:poststelle@ldi.nrw.de">poststelle@ldi.nrw.de</a><br>
  Telefon: <a href="tel:+49211384240">+49 211 38424 - 0</a><br>
  Fax: +49 211 38424 - 999
</p>
<h2>
  8. Information über Ihr Widerspruchsrecht nach Art. 21 DSGVO
</h2>
<h3>
  a) Einzelfallbezogenes Widerspruchsrecht
</h3>
<p>
  Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die
  Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund von Artikel 6 Absatz 1 Buchstabe e der
  DSGVO (Datenverarbeitung im öffentlichen Interesse) und Artikel 6 Absatz 1 Buchstabe f der DS-GVO
  (Datenverarbeitung auf der Grundlage einer Interessenabwägung) erfolgt, Widerspruch einzulegen; dies gilt auch
  für ein auf diese Bestimmung gestütztes Profiling.
</p>
<p>
  Legen Sie Widerspruch ein, werden wir Ihre personenbezogenen Daten nicht mehr verarbeiten, es sei denn, wir
  können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und
  Freiheiten überwiegen oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von
  Rechtsansprüchen.
</p>
<h3>
  b) Widerspruchsrecht gegen eine Verarbeitung von Daten für Zwecke der Direktwerbung
</h3>
<p>
  In Einzelfällen verarbeiten wir Ihre personenbezogenen Daten, um Direktwerbung zu betreiben. Sie haben das Recht,
  jederzeit Widerspruch gegen die Verarbeitung Sie betreffender personenbezogener Daten zum Zwecke derartiger
  Werbung einzulegen; dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht.
</p>
<p>
  Widersprechen Sie der Verarbeitung für Zwecke der Direktwerbung, so werden wir Ihre personenbezogenen Daten nicht
  mehr für diese Zwecke verarbeiten.
</p>
<p
  class="version"
  *ngIf="versionLabel"
>
  Stand: {{ versionLabel }}
</p>
